import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CATALOG, INDUSTRIES, LOGO_URL } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="bg-[#14212b] text-slate-300">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block bg-white rounded-lg px-3 py-2 mb-4">
              <img src={LOGO_URL} alt="mattressDIRECT.in" className="h-12 w-auto" />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              Better sleep. Direct to you. Your trusted partner for bulk mattress supply across India - reliable quality, custom solutions and on-time delivery at scale.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Popular Mattresses</h4>
            <ul className="space-y-2.5 text-sm">
              {CATALOG.slice(0, 6).map((p) => (
                <li key={p.id}>
                  <Link to={`/industries/${p.industries[0]}`} className="text-slate-400 hover:text-white transition-colors">{p.displayName}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Industries</h4>
            <ul className="space-y-2.5 text-sm">
              {INDUSTRIES.map((i) => (
                <li key={i.slug}>
                  <Link to={`/industries/${i.slug}`} className="text-slate-400 hover:text-white transition-colors">{i.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Contact</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3"><Phone size={17} className="text-[#f4520b] mt-0.5 shrink-0" /> +91 98765 43210</li>
              <li className="flex items-start gap-3"><Mail size={17} className="text-[#f4520b] mt-0.5 shrink-0" /> sales@mattressdirect.in</li>
              <li className="flex items-start gap-3"><MapPin size={17} className="text-[#f4520b] mt-0.5 shrink-0" /> Manufacturing Unit, Industrial Area, India</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} mattressDIRECT.in - Better Sleep. Direct To You. All rights reserved.</p>
          <p>Reliable supply. Consistent quality. Custom solutions.</p>
        </div>
      </div>
    </footer>
  );
}
